<template>
  <div class="note">
    <div v-if="!editing" class="note-tile">
      <div class="note-header">
        <div>
          <img class="note-user-icon" :src="note.authorIconUrl" title="Update your avatar at https://gravatar.com" />
          {{note.authorName}}
          <span v-if="commentsMode">
            commented
          </span>
          <span class="note-type" :class="typeClass" v-else="commentsMode">
            <i class="fa" :class="badgeClass"></i>
          </span>
        </div>
        <div>
          <span class="date">
            {{note.time}}
          </span>
          <a class="note-edit note-edit-enabled" v-if="note.canEdit" href="#" @click.prevent="edit">
            <i class="fa fa-edit"></i>
            edit
          </a>
          <a class="note-edit note-edit-disabled" v-if="note.authoredByUser && !note.canEdit" disabled title="Comments can only be edited up to 24 hours after writing them. Contact an administrator if you really need to edit it.">
            <i class="fa fa-edit"></i>
            edit
          </a>
        </div>
      </div>
      <div v-html="note.html" class="note-html"></div>
      <div class="note-attachments" v-if="note.files.length > 0">
        <a :href="file.url" v-for="file in note.files" class="attachment" :title="file.name">
          <div>
            <img :alt="file.name" :src="file.thumbnail" v-if="file.thumbnail"/>
            <i class="fa fa-file-o" v-else></i>
          </div>
          {{file.name}}
        </a>
      </div>
    </div>
    <NoteForm
      ref="form"
      v-if="editing"
      :initialMarkdown="note.markdown"
      :initialType="note.type"
      :initialFiles="note.files"
      :commentsMode="commentsMode"
      @save="onEditSave"
      @cancel="onEditCancel"
    />
  </div>
</template>

<script>
  import NoteForm from './NoteForm';
  import {showError} from 'perform-base/js/flashes';

  export default {
    props: [
      'note',
      'commentsMode',
    ],
    data() {
      return {
        editing: false,
      }
    },
    components: {
      NoteForm,
    },

    computed: {
      badgeClass() {
        var badgeClasses = [
          'fa-comment',
          'fa-envelope',
          'fa-phone',
          'fa-user',
          'fa-mobile',
        ];

        return badgeClasses[this.note.type];
      },
      typeClass() {
        return 'note-type-'+this.note.type;
      },
    },

    methods: {
      edit() {
        this.editing = true;
        this.$nextTick(() => {
          this.$refs.form.focus();
        });
      },
      onEditSave(e) {
        this.$store.dispatch('editNote', {
          id: this.note.id,
          markdown: e.markdown,
          files: e.files,
          type: e.noteType,
        })
            .then(() => {
              this.editing = false;
              this.saving = false;
              this.$refs.form.reset();
            })
            .catch((e) => {
              console.error(e);
              showError('An error occurred updating this comment. Try again later.');
            });
      },
      onEditCancel(e) {
        this.editing = false;
      },
    },
  }
</script>



// WEBPACK FOOTER //
// assets/js/components/Note.vue